import * as Yup from 'yup';

import { COUNTRY_CONFIG } from '../../constants/countries';
import { Country } from '../../gql/generated/graphql';
import { formatMileage } from '../helpers';

export const odometerValidation = (country: Country) => {
  const { max, unit } = COUNTRY_CONFIG[country].odometer;

  return Yup.number()
    .nullable()
    .integer('Please enter a whole number')
    .required('Please enter a value')
    .moreThan(0, 'Must be greater than 0')
    .lessThan(
      max,
      `High mileage alert! We are usually unable to secure financing options for lease cars over ${formatMileage(
        max,
      )} ${unit}. Thank you.`,
    );
};
